<template>
    <b-container fluid class="p-0">
        <show-notif v-model="showNotif"/>
        <b-row class="mb-3 justify-content-between align-items-center">
            <b-col sm="12" md="4">
                <create-user tag="b-btn" icon="plus" icon-class="align-middle mx-1" label="Add User" @refresh="refresh"/>
            </b-col>
        </b-row>
        <b-table
            ref="table"
            class="bg-white reportTable"
            show-empty
            stacked="md"
            :items="items"
            head-variant="dark"
            :empty-text="'No Records'"
            sort-icon-left
            :empty-filtered-text="'NoRecords'"
            details-td-class="p-0 table-light"
            :fields="fields"
            :current-page="currentPage"
            :per-page="perPage"
            :busy.sync="progressing"
            @context-changed="getItems"
            sort-by="Submitted"
            sort-desc
        >
            <template v-slot:cell(actions)="data">
                <edit-user v-if="data.item.RoleID != 6" style="cursor: pointer" :value="{...data.item}" tag="span" icon="pencil-alt" icon-class="align-middle" @refresh="refreshEdit"/>
                <edit-user v-if="data.item.RoleID == 6 && isSameOwner(data.item)" style="cursor: pointer" :value="{...data.item}" tag="span" icon="pencil-alt" icon-class="align-middle" @refresh="refreshEdit"/>
            </template>
            <template v-slot:cell(Phone)="data">
                <span>
                    {{formatPhoneNumber(data.item.Phone)}}
                </span>
            </template>
        </b-table>
        <b-pagination
            v-if="items.length > 10"
            v-model="currentPage"
            :total-rows="items.length"
            :per-page="perPage"
            class="my-3"
        ></b-pagination>
        <b-card no-body>
            <b-card-header>
                <div class="d-flex flex-row justify-content-between align-items-center">
                    <div class="font-weight-bold">
                        User Permissions Guide
                    </div>
                    <section class="d-flex small align-items-center">
                        <div class="d-flex flex-row font-weight-bold mr-4">
                            <div class="allowed-badge"></div>
                            <span class="mx-1">Allowed</span>
                        </div>
                        <div class="d-flex flex-row font-weight-bold mr-4">
                            <div class="not-allowed-badge"></div>
                            <span class="mx-1">Not Allowed</span>
                        </div>
                        <div class="d-flex flex-row font-weight-bold">
                            <div class="permission-badge"></div>
                            <span class="mx-1">Permission Requierd</span>
                        </div>
                    </section>
                </div>
            </b-card-header>
            <b-card-body>
                <div class="mb-2">
                    <b-img src="/img/role1.jpg" fluid-grow/>
                </div>
                <div>
                    <b-img src="/img/role2.jpg" fluid-grow/>
                </div>
            </b-card-body>
        </b-card>
    </b-container>
</template>

<script>

    import CreateUser from "./createUser";
    import editUser from "./editUser";
    import showNotif from "./components/showNotif";
    export default {
        name: "users",
        components: {
            CreateUser,
            showNotif,
            editUser
        },
        data() {
            return {
                progressing: false,
                fields: [
                    {key: 'FirstName', label: 'First Name'},
                    {key: 'LastName', label: 'Last Name'},
                    {key: 'Phone', label: 'Cell Phone Number'},
                    {key: 'Email', label: 'Email'},
                    {key: 'CreateDate', label: 'Add Date'},
                    {key: 'Role', label: 'Role'},
                    {key: 'actions', label: ''}
                ],
                items: [],
                currentPage: 1,
                perPage: 10,
                showNotif: false
            }
        },
        metaInfo () {
            return {
                title: 'Users'
            }
        },
        watch: {
            '$store.state.selectedRestaurantId': {
                // get restaurant orders
                handler: function (newVal) {
                    if (newVal) {
                        this.$nextTick(() => {
                            this.getItems(this.$refs.table.context)
                        })
                    }
                },
                immediate: true
            }
        },
        methods: {
            isSameOwner(data) {
                return localStorage.getItem('ClientTypeID') == data.RoleID && data.ClientID == localStorage.getItem('userID')
            },
            getItems (ctx) {
                this.progressing = true
                return this.$api.getRestaurant.GetDashboardRestaurantClient(this.filter(ctx), true).then(res => {
                    this.progressing = false
                    if (res.success) {
                        this.items = res.RestaurantClients
                        
                        this.items.forEach(i => {
                            if(i.Phone.substring(0,2) == "+1"){//removing +1 for display
                                i.Phone= i.Phone.substring(2)
                            }
                        });
                        return res.RestaurantClients
                    }
                }).catch(() => {

                })
            },
            filter(ctx, isCount) {
                const filter = {}
                filter.RestaurantID = this.$store.state.selectedRestaurantId
                filter.UserID = localStorage.getItem('userID')
                return filter
            },
            refreshEdit () {
                this.getItems(this.$refs.table.context)
            },
            refresh () {
                this.showNotif = true
                this.getItems(this.$refs.table.context)
            },
            formatPhoneNumber (phone) {
                if (!phone) return ''
                else {
                    return "***-***-*"+ phone[7] + phone[8] + phone[9];
                    // return phone[0] + phone[1] + phone[2] + '-' + phone[3] + phone[4] + phone[5] + '-' + phone[6] + phone[7] + phone[8] + phone[9]
                }
            },
            searchInReport () {
                // this.currentPage = 1
                // this.getItems(this.$refs.table.context)
            },
            // resetSearch () {
            //     this.currentPage = 1
            //     this.Search = ''
            //     this.getItems(this.$refs.table.context).then(() => {
            //         this.showResetBtn = false
            //     })
            // },
        }
    }
</script>

<style scoped>
    .activeBtn {
        background: #f5c31d !important;
        border-color: #c8ced3 !important;
        font-weight: bold;
    }
    .deactiveBtn {
        background: #fff !important;
        border-color: #c8ced3 !important;
        color: #c8ced3 !important;
        font-weight: bold;
    }
    .allowed-badge{
        background-color: #b6d7a8;
        height: 10px;
        width: 40px;
    }

    .not-allowed-badge{
        background-color: red;
        height: 10px;
        width: 40px;
    }

    .permission-badge{
        background-color: yellow;
        height: 10px;
        width: 40px;
    }

</style>
